import React from 'react';
import { LinkLegacy as Link } from '@leagueplatform/routing';
import { TextAction } from '@leagueplatform/genesis-core';

export const GenesisRouterLink = (props) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <TextAction as={Link} {...props} />
);
